import React from 'react';
import PropTypes from 'prop-types';
import FlavorImage from './FlavorImage';
import './ProductGrid.scss';
import { getProductImagePath } from '../utils/productImages';

const CATEGORY_META = {
  Pocket: {
    eyebrow: 'Fast-Acting Minis',
    title: 'Good Vibes Pocket',
    badge: '150mg THC'
  },
  OG: {
    eyebrow: 'Core Collection',
    title: 'Good Vibes',
    badge: '500mg THC'
  },
  Rosin: {
    eyebrow: 'Solventless Drop',
    title: 'Good Vibes Rosin',
    badge: 'Hybrid • Indica • Sativa'
  },
  Plus: {
    eyebrow: 'Functional Blends',
    title: 'Good Vibes Plus',
    badge: 'Wellness-Forward'
  },
  X: {
    eyebrow: 'High Potency',
    title: 'Good Vibes X',
    badge: '1000mg THC'
  }
};

// Helper to group products by category
function groupProducts(products) {
  const groups = {
    Pocket: [],
    OG: [],
    Rosin: [],
    Plus: [],
    X: []
  };
  products.forEach(product => {
    if (product.brand === 'Good Vibes Pocket') groups.Pocket.push(product);
    else if (product.brand === 'Good Vibes' && product.thc?.includes('500mg')) groups.OG.push(product);
    else if (product.brand === 'Good Vibes Rosin') groups.Rosin.push(product);
    else if (product.brand === 'Good Vibes +' || product.brand === 'Good Vibes Plus' || product.brand === 'Good Vibes + Sleep') groups.Plus.push(product);
    else if (product.brand === 'Good Vibes X') groups.X.push(product);
  });
  return groups;
}

const ProductGrid = ({ products, onSelect }) => {
  const grouped = groupProducts(products);

  // Helper to get ratio string for Plus line
  const getRatio = product => {
    if (product.thc) {
      return <span className="ratio-label">{product.thc}</span>;
    }
    return null;
  };

  const getRosinType = product => {
    if (product.brand === 'Good Vibes Rosin' && product.thc) {
      return <span className="ratio-label">{product.thc}</span>;
    }
    return null;
  };

  return (
    <div className="product-grid">
      {Object.entries(grouped).map(([category, items]) => (
        items.length > 0 && (
          <section
            key={category}
            className={`product-grid-section product-grid-section--${category.toLowerCase()}`}
          >
            <div className="product-grid-section-header">
              <div className="product-grid-section-pill">
                <span className="product-grid-section-title">
                  {CATEGORY_META[category]?.title || category}
                </span>
                {CATEGORY_META[category]?.badge && (
                  <span className="product-grid-section-badge">
                    {CATEGORY_META[category].badge}
                  </span>
                )}
              </div>
              <span className="product-grid-section-eyebrow">
                {CATEGORY_META[category]?.eyebrow || category}
              </span>
            </div>
            <div className="product-grid-section-grid">
              {items.map(product => (
                <div
                  key={product.canonicalName}
                  className="product-card"
                  onClick={() => onSelect(product)}
                >
                  {product.limited && (
                    <span className="product-card-limited-badge">★ Limited</span>
                  )}
                  {product.seasonal && (
                    <span className="product-card-seasonal-badge">♥ Seasonal</span>
                  )}
                  <div className="product-card-image-wrapper">
                    <FlavorImage 
                      src={getProductImagePath({ imagePath: product.imagePath, transparentImagePath: product.transparentImagePath })} 
                      alt={product.displayName} 
                    />
                  </div>
                  <div className="product-name">{product.displayName}</div>
                  {/* Show ratio for Plus line */}
                  {category === 'Plus' && getRatio(product) && (
                    <div className="product-ratio">{getRatio(product)}</div>
                  )}
                  {category === 'Rosin' && getRosinType(product) && (
                    <div className="product-ratio">{getRosinType(product)}</div>
                  )}
                </div>
              ))}
            </div>
          </section>
        )
      ))}
    </div>
  );
};

ProductGrid.propTypes = {
  products: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default ProductGrid;
